import { useEffect } from "preact/hooks";
import { Masthead } from "../components/Masthead";
import { CourseView } from "../components/CourseView";
import { idx } from "../store";

export function CoursePage({ id }: { id: string }) {
  const cid = decodeURIComponent(id);
  const c = idx.value!.courses.get(cid);
  useEffect(() => { document.title = c ? `${c.name} · ${c.fac} · Slušam` : "Predmet · Slušam"; }, [cid]);
  return (
    <>
      <Masthead compact />
      <div class="page drawer-like"><div class="crumbs"><a href="/">Katalog</a> / {c && <a href={`/u/${c.fac}`}>{c.fac}</a>}</div><CourseView id={cid} /></div>
    </>
  );
}
